// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-G1":"G1_outdoor-recreation-G1__rrUqq"};